import { HiddenField } from "../../Form";
import { translate } from "../../../intl";
import {
  UseFormReturn,
  FieldPath,
  FieldValues,
  PathValue,
} from "react-hook-form";
import { SecondaryButton } from "../../../ui/Button";

interface FormDraftButtonProps<TFieldValues extends FieldValues> {
  readOnly: boolean;
  isSubmitting: boolean;
  disabled?: boolean;
  form: UseFormReturn<TFieldValues>;
  handleSubmit: () => void;
}

export const FormDraftButton = <TFieldValues extends FieldValues>({
  readOnly,
  isSubmitting,
  disabled,
  form,
  handleSubmit,
}: FormDraftButtonProps<TFieldValues>) => {
  const draft = "draft" as FieldPath<TFieldValues>;
  return (
    <>
      <HiddenField form={form} name={draft} defaultValue={false} />

      {!readOnly && (
        <SecondaryButton
          style={{ float: "right", marginLeft: "1rem" }}
          disabled={isSubmitting || disabled}
          onClick={() => {
            form.setValue(
              draft,
              true as PathValue<TFieldValues, FieldPath<TFieldValues>>,
            );
            handleSubmit();
          }}
        >
          {isSubmitting && form.getValues(draft) === true
            ? translate("formGeneric.submitting")
            : translate("formGeneric.saveDraft")}
        </SecondaryButton>
      )}
    </>
  );
};
